import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IApplicationData } from 'core-components/sitebuilder/models/IApplication'
import { IUser } from 'core-components/sitebuilder/models/IUser'
import { TModel as TNotification } from 'src/core/classes/models/Notification'
import { appInitialState } from 'src/core/store/constants'
import { simulationApi } from 'src/core/store/service/simulation'
import { disableSimulation } from 'src/core/store/service/simulation/disableSimulation'
import { enableSimulation } from 'src/core/store/service/simulation/enableSimulation'
import { IAuthError, ISimulationRolesCollection } from 'src/core/store/state'

const appSlice = createSlice({
  name: '@app',
  initialState: appInitialState,
  extraReducers: (builder) => {
    builder.addMatcher(simulationApi.endpoints.stopSimulation.matchPending, (state) => {
      state.simulation = false
      disableSimulation()
    })
    builder.addMatcher(
      simulationApi.endpoints.startSimulation.matchFulfilled,
      (appState, { payload }) => {
        enableSimulation({
          appState,
          accessToken: payload['AccessToken'],
          refreshToken: payload['RefreshToken'],
        })
      }
    )
  },
  reducers: {
    // use in lut
    setPublishingMode(state, action: PayloadAction<boolean>) {
      state.publishingMode = action.payload
    },
    setUser(state, action: PayloadAction<IUser>) {
      state.user = action.payload
    },
    setApp(state, action: PayloadAction<IApplicationData>) {
      state.app = action.payload
    },
    setSimulationRoles(state, action: PayloadAction<ISimulationRolesCollection>) {
      state.simulationRoles = action.payload
    },
    setAuthError(state, action: PayloadAction<IAuthError>) {
      state.authError = action.payload
    },
    addNotifications(state, action: PayloadAction<TNotification[]>) {
      state.notifications = [...action.payload, ...state.notifications]
    },
    removeNotifications(state, action: PayloadAction<TNotification[]>) {
      if (action.payload.length) {
        state.notifications = state.notifications.filter((i) => {
          return action.payload.findIndex((n) => n.EntryId === i.EntryId) === -1
        })
      }
    },
    setQueueProgress(state, action: PayloadAction<number>) {
      state.queueProgress = action.payload
    },
  },
})

export const {
  setUser,
  setApp,
  setSimulationRoles,
  setAuthError,
  addNotifications,
  removeNotifications,
  setPublishingMode,
  setQueueProgress,
} = appSlice.actions

export default appSlice.reducer
